{
  "title": "Home",
  "welcome": "Welcome to Home, {{name}}, {{age}} years old, a {{job}}"
}
